<template>
  <div class="content">

    <div class="card-box data-table">
      <div class="inp-list">
        <!-- <div class="item">
          <span class="label">{{ $t("g.create_at") }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div> -->
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.CodePathID"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <div class="item">
          <span class="label">{{ $t('device.status') }}</span>
          <el-select class="inp" size="small" v-model="formData.valStatus" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.statuses" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="label">{{ $t('activityManage.title') }}</span>
          <el-input class="inp" size="small" v-model="formData.name"
            :placeholder="$t('activityManage.title')"></el-input>
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
        <el-button @click="func.showAddDataDialog" type="primary" class="btn-add">{{ $t('g.added') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table @row-click.self="func.showDetails" :data="formData.tableData" style="width: 100%">
        <el-table-column prop="Id" label="ID" width="60">
        </el-table-column>
        <el-table-column prop="Name" :label="$t('activityManage.title')" width="140">
        </el-table-column>
        <el-table-column prop="NamePath" :label="$t('g.operator_ownership')" :show-overflow-tooltip='true'
          min-width="130">
        </el-table-column>
        <el-table-column width="80" :label="$t('expenses.type')">
          <template #default="scope">
            {{ render.promotionType[scope.row.PromotionType - 1].label }}
          </template>
        </el-table-column>
        <el-table-column width="100" :label="$t('expenses.status')">
          <template #default="scope">
            <el-tag :class="scope.row.Status == 1 ? 'tag-success' : 'tag-fail'">
              {{ scope.row.Status == 1 ? $t('expenses.statuses.enabled') : $t('expenses.statuses.disabled') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="StartTimeStr" min-width="180" :label="$t('activityManage.start_time')">
        </el-table-column>
        <el-table-column prop="EndTimeStr" min-width="180" :label="$t('activityManage.end_time')">
        </el-table-column>
        <el-table-column prop="CreateAtStr" min-width="180" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column width="84" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button @click="func.edit(scope.row)" class="btn-edit" type="primary">{{
              $t('g.edit')
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" width="80%" align-center>
      <el-descriptions border>
        <el-descriptions-item label="#">{{ formData.curData.Id }}</el-descriptions-item>
        <el-descriptions-item :label="$t('activityManage.title')">{{ formData.curData.Name }}</el-descriptions-item>
        <el-descriptions-item :label="$t('expenses.type')">
          {{ render.promotionType[formData.curData.PromotionType - 1].label }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('expenses.status')"> <el-tag
            :class="formData.curData.Status == 1 ? 'tag-success' : 'tag-fail'">
            {{ formData.curData.Status == 1 ? $t('expenses.statuses.enabled') : $t('expenses.statuses.disabled') }}
          </el-tag></el-descriptions-item>
        <el-descriptions-item :label="$t('g.operator_ownership')">{{ formData.curData.NamePath }}</el-descriptions-item>
        <el-descriptions-item :label="$t('activityManage.end_time')">{{ formData.curData.StartTimeStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('activityManage.end_time')">{{ formData.curData.EndTimeStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{ formData.curData.CreateAtStr }}</el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="default" @click="formData.dialogDisplayVisible = false">{{ $t('g.btn_cancel') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogVisible" width="70%">
      <el-form label-width="100px" :model="formData.curData">
        <div class="el-form-row line-3">
          <el-form-item :label="$t('activityManage.title')">
            <el-input v-model="formData.curData.Name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('expenses.status')">
            <el-select class="inp" v-model="formData.curData.Status" :placeholder="$t('g.choose')">
              <el-option v-for="item in render.updateStatuses" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('activityManage.type')">
            <el-select class="inp" v-model="formData.curData.PromotionType" :placeholder="$t('g.choose')">
              <el-option v-for="item in render.promotionType" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.value == 1">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('g.operator')">
            <el-cascader style="width: 100%;" :clearable="true" v-model="formData.curData.CodePathID"
              :props="formData.props" :options="render.cascade_options_direct" />
          </el-form-item>
          <el-form-item :label="$t('coupon.time')" width="350px">
            <el-date-picker class="inp" v-model="formData.deadlineTime" value-format="YYYY-MM-DD" type="daterange"
              unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
              :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="operate-amount" v-if="formData.operateMothed == 2">
          <div class="title">
            <div class="l1">增加赠送金额</div>
            <el-button type="primary" class="btn-add" @click="func.addtier()">{{ $t('device.add') }}</el-button>
          </div>
          <div class="content">
            <div class="item" v-for="item, idx in formData.promotionTiers" :key="idx">
              <div class="txt">充值</div>
              <el-input type="number" v-model="item.RechargeMinAmount" style="width:200px;"></el-input>
              <div class="txt">元,赠送</div>
              <el-input style="width:200px;" type="number" v-model="item.GiveAmount"></el-input>
              <div class="txt">元</div>
              <el-button type="danger" class="btn-delete" @click="func.deltier(idx)">{{ $t('device.delete')
              }}</el-button>
            </div>
          </div>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="func.updateData()">{{ $t('g.btn_confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { reactive, onMounted, computed, watch } from 'vue'
import { operators, updateOperators, shortcuts, operatorList, cascade_options_direct } from '@/data/default'
import { toDay } from '@/common/func'
import axios from "axios"
import { ElMessage } from 'element-plus'
import i18n from '@/data/i18n/index'
import { isOperator, isPath, isAdmin } from '@/data/token'

export default {
  name: 'ExpensesCombo',
  props: {
    propId: String,
  },
  setup(props) {
    const t = i18n.global.t
    const tableData = []
    const statuses = [
      {
        label: t('expenses.statuses.all'),
        value: -1
      },
      {
        label: t('expenses.statuses.enabled'),
        value: 1
      },
      {
        label: t('expenses.statuses.disabled'),
        value: 0
      }
    ]
    const promotionType = [{
      label: t('depositBonus.balanceRecharge'),
      value: 1
    }, {
      label: t('depositBonus.cardRecharge'),
      value: 2
    }]
    const types = [
      {
        label: t('expenses.types.all'),
        value: 0
      },
      {
        label: t('expenses.types.by_month'),
        value: 1
      },
      {
        label: t('expenses.types.by_times'),
        value: 2
      },
      {
        label: t('expenses.types.by_day'),
        value: 3
      }
    ]

    const render = reactive({
      operators,
      statuses,
      types,
      promotionType,
      updateOperatorsList: operatorList,
      updateStatuses: [
        {
          label: t('expenses.enable'),
          value: 1
        },
        {
          label: t('expenses.disable'),
          value: 0
        }
      ],
      shortcuts,
      cascade_options_direct,
      capget: []
    })
    const formData = reactive({
      tableData,
      curData: {},
      promotionTiers: [],
      valTime: '',
      valStatus: -1,
      valType: 0,
      dialogVisible: false,
      operateMothed: 1,// 1 add 2 edit
      dialogDisplayVisible: false,
      curPage: 1,
      pageSize: 10,
      total: 500,
      CodePathID: 0,
      devType: [],
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
      props2: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Code",
        emitPath: false,
        checkStrictly: true
      },
      IsStartWith: 1,
      is_opt: false
    })
    const func = {
      search() {
        console.log('formData', formData)
        func.loadData()
      },
      async showDetails(row, column) {
        if (column && column.label == t('g.operation')) {
          return;
        }
        // formData.promotionTiers = row.promotionTiers
        formData.curData = row;
        formData.dialogDisplayVisible = true;
      },
      edit(row, column, e) {
        formData.curData = row
        formData.promotionTiers = row.promotionTiers || []
        formData.curData.CodePathID = row.CodePathID
        formData.operateMothed = 2
        if (row.StartTimeStr && row.EndTimeStr) {
          formData.deadlineTime = [row.StartTimeStr.slice(0, 10), row.EndTimeStr.slice(0, 10)]
        }

        formData.dialogVisible = true
      },
      addtier() {
        console.log(JSON.stringify());

        formData.promotionTiers.push({
          RechargeMinAmount: "",
          GiveAmount: "",
        })
      },
      deltier(idx) {
        let tmp = []
        for (let i = 0; i < formData.promotionTiers.length; i++) {
          if (idx == i) {
            let item = formData.promotionTiers[i]
            // if (item.Id) {
            //   await axios.delete(`/admin/device/charge/rule?id=` + item.Id, {
            //   })
            // }
            continue;
          }
          tmp.push(formData.promotionTiers[i])
        }
        formData.promotionTiers = tmp
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      showAddDataDialog() {
        formData.curData = {}
        // formData.curData = {
        //   CodePath: operatorList.length ? operatorList[0].value : "",
        // } 
        formData.operateMothed = 1
        formData.promotionTiers = []
        formData.deadlineTime = []
        formData.dialogVisible = true
      },
      async updateData() {
        // console.log("updateOrCreate Data",formData.curData)
        if (typeof (formData.curData.PromotionType) == 'undefined') {
          ElMessage({
            type: 'error',
            message: t('expenses.tips.type')
          })
          return
        }
        if (typeof (formData.curData.Status) == 'undefined') {
          ElMessage({
            type: 'error',
            message: t('expenses.tips.staus')
          })
          return
        }
        if (typeof (formData.curData.CodePathID) == 'undefined' && !formData.curData.Id) {
          ElMessage({
            type: 'error',
            message: t('expenses.tips.agent_code')
          })
          return
        }

        let params = {
          Name: formData.curData.Name,
          PromotionType: formData.curData.PromotionType,
          Status: formData.curData.Status,
          StartTime: formData.curData.StartTime,
          EndTime: formData.curData.EndTime
        }

        if (formData.curData.CodePathID) {
          params.CodePathId = formData.curData.CodePathID
        }
        if (formData.deadlineTime) {
          params.StartTime = Math.floor(Date.parse(formData.deadlineTime[0] + " 00:00:00") / 1000)
          params.EndTime = Math.floor(Date.parse(formData.deadlineTime[1] + " 23:59:59") / 1000)
        }

        try {
          if (formData.curData.Id) {
            params.Id = formData.curData.Id
            if (formData.promotionTiers.length) {
              // let arr = [...formData.promotionTiers]
              // arr.forEach(item => {
              //   item.RechargeMinAmount = Number(item.RechargeMinAmount) * 100;
              //   item.GiveAmount = Number(item.GiveAmount) * 100;
              //   if (item.RechargeMinAmount < item.GiveAmount) {
              //     alert('赠送金额不能大于充值金额')
              //     return
              //   }

              // })
              let arr = formData.promotionTiers.map(item => ({
                ...item,
                RechargeMinAmount: Number(item.RechargeMinAmount) * 100,
                GiveAmount: Number(item.GiveAmount) * 100
              }));

              let jsonData = JSON.stringify(arr)

              await axios.post('/admin/promotion/updatetier', {
                Id: formData.curData.Id,
                data: jsonData
              }

              )
            }

            await axios.post('/admin/promotion/edit', params)
          } else {
            await axios.post('/admin/promotion/add', params)
          }
        } catch (e) {

        }
        formData.dialogVisible = false
        func.loadData()
      },
      opt_operator() {
        formData.curData.DevTypeStr = ''
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.valStatus != -1) {
            params.status = formData.valStatus
          }
          if (formData.CodePathID) {
            params.codePathId = formData.CodePathID
          }
          params.isStartWith = formData.isStartWith
          if (formData.valType) {
            params.type = formData.valType
          }
          if (formData.valComboCode) {
            params.ComboCode = formData.valComboCode
          }
          if (props.propId) {
            formData.name = props.propId
          }
          if (formData.name) {
            params.name = formData.name
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          let res = await axios.get(`/admin/promotion/get`, {
            params
          })
          formData.total = res.Total
          res.List.map((item) => {
            item.CreateAtStr = toDay(item.CreatedAt)
            item.StartTimeStr = toDay(item.StartTime)
            item.EndTimeStr = toDay(item.EndTime)
            if (item.promotionTiers && item.promotionTiers.length > 0) {
              item.promotionTiers.map((item2) => {
                item2.GiveAmount = item2.GiveAmount / 100
                item2.RechargeMinAmount = item2.RechargeMinAmount / 100
              })
            }

          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      func.loadData()
      if (localStorage.getItem('user_info')) {
        formData.user_info = JSON.parse(localStorage.getItem('user_info'))
        if (formData.user_info.RoleId == 14 || formData.user_info.RoleId == 25 || formData.user_info.RoleId == 18) {
          formData.is_opt = true
        }
      }

    })
    return {
      func,
      render,
      isOperator,
      isAdmin,
      formData,
      isPath
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;


        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;

    :deep(.el-form-item) {
      width: 33%;
    }

    .inp {
      width: 100%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  :deep(.m-dialog) {
    max-width: 50rem;
  }

  .operate-amount {
    .title {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .l1 {
        font-size: 18px;
        font-weight: bold;

      }
    }

    .item {
      display: flex;
      align-items: baseline;
      border: 1px solid #d9d9d9;
      padding: 0.25rem 0.625rem;
      border-radius: 0.3rem;
      margin-bottom: 0.625rem;

      >.txt {
        padding: 0 10px;
        width: 140px;
      }
    }

  }

}
</style>